import dayjs from 'dayjs';
import arraySupport from 'dayjs/plugin/arraySupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import localeData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from 'dayjs/plugin/weekday';

dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(LocalizedFormat);
dayjs.extend(isoWeek);
dayjs.extend(arraySupport);
dayjs.extend(updateLocale);
dayjs.extend(duration);
dayjs.extend(customParseFormat);

export {
	dayjs,
	weekday,
	localeData,
	LocalizedFormat,
	isoWeek,
	arraySupport,
	updateLocale,
	duration,
	customParseFormat,
};
